export default __webpack_public_path__ + "e3062dae6170a60bfb945837438242c2.png";